import { forwardRef, useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { projectService } from "../services/project.service";
import { IOption } from "Dashboard/domain/IOption";

const ProjectTypeSelectCreate = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const { value, setValue } = props;
  const [valueLocal, setValueLocal] = useState<IOption | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const data = await projectService.getTypes();
      const op = data.map((type) => {
        return {
          label: type.name,
          value: type.typeId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getValue = () => {
    if (value) {
      const values = options.filter((o) => o.value === value);
      if (values[0]) {
        return values[0];
      }
    }
    return valueLocal;
  };

  const setValueFunction = (option: IOption | undefined) => {
    if (setValue) {
      setValue(option);
    }
    setValueLocal(option);
  };

  const handleChange = (newValue: any, actionMeta: any) => {
    setValueFunction(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  const createOption = async (name: string): Promise<IOption> => {
    try {
      const type = await projectService.createType(name);
      return {
        label: type.name,
        value: type.typeId,
      };
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = async (inputValue: any) => {
    try {
      setIsLoading(true);
      const newOption = await createOption(inputValue);
      setOptions([...options, newOption]);
      handleChange(newOption, null);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p> Dodaj: {inputValue}</p>;
  };

  const isValidNewOption = (inputValue: string) => {
    // Check if there's an exact match in the options
    const hasExactMatch = options.some(option =>
      'label' in option && option.label.toLowerCase() === inputValue.toLowerCase());

    // Only show "Create" option if there's input, no exact match, and isValidNewOption is true
    return !!inputValue && !hasExactMatch && props.isValidNewOption !== false;
  };

  const noOptionsMessage = ({ inputValue }: { inputValue: string }) => {
    if (!inputValue) return null; // No message when dropdown is just opened
    if (props.isValidNewOption === false) return "Ne postoji";
    return null; // When isValidNewOption is true, formatCreateLabel will show instead
  };

  return (
    <CreatableSelect
      isValidNewOption={isValidNewOption}
      onKeyDown={(event) => {
        if (event.key === 'Enter' && props.isValidNewOption === false) {
          event.preventDefault();
        }
      }}
      isClearable
      menuPosition="fixed"
      styles={props.customStyles}
      ref={ref}
      options={options}
      value={getValue()}
      onChange={handleChange}
      onCreateOption={handleCreate}
      inputValue={props.preserveInput && inputValue}
      onInputChange={props.preserveInput &&
        ((newVal) => setInputValue(newVal))}
      onMenuClose={props.preserveInput &&
        (() => setInputValue(undefined))}
      onMenuOpen={props.preserveInput &&
        (() => setInputValue(value?.label))}
      formatCreateLabel={formatCreate}
      noOptionsMessage={noOptionsMessage}
      placeholder={""}
      isLoading={isLoading}
      isDisabled={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default ProjectTypeSelectCreate;
